<template>
  <div class="product-variant-shell">
    <div ref="variantShell" class="variant-shell" @scroll="applyShadow">
      <div v-if="!useListView" class="variant-shell__top">
        <div class="variant-shell__headline" v-html="title"></div>
      </div>

      <slot :applyArticleNumberShadow="applyArticleNumberShadow" :applyStockPriceShadow="applyStockPriceShadow"></slot>
    </div>
    <div v-if="$slots['expand-all'] !== undefined" class="variant-shell__actions-container">
      <slot name="expand-all"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    cardId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      applyArticleNumberShadow: false,
      applyStockPriceShadow: false

    }
  },
  computed: {
    ...mapGetters('ui', ['useListView']),
    ...mapGetters('productVariants', ['isExpanded'])
  },
  mounted() {
    this.applyShadow()
  },
  methods: {
    applyShadow() {
      const hasOverflow = this.$refs.variantShell.scrollWidth > this.$refs.variantShell.clientWidth

      if(!hasOverflow) return
      if(this.$refs.variantShell.scrollLeft > 0) {
        this.applyArticleNumberShadow = true
      } else {
        this.applyArticleNumberShadow = false
      }

      var maxScrollLeft = this.$refs.variantShell.scrollWidth - this.$refs.variantShell.clientWidth
      if(this.$refs.variantShell.scrollLeft === maxScrollLeft) {
        this.applyStockPriceShadow = false
      } else {
        this.applyStockPriceShadow = true
      }
    }
  }
}
</script>

<style lang="scss">
.product-variant-shell {
  grid-column: 1 / -1;
  margin-top: measure(grid-gap-negative);
}

.variant-shell {
  overflow: auto;
  max-height: 50vh;
}

// .grid--grid .product-shell--show-variants {
//   width: 100%;

//   @include media(grid-two) {
//     @include expanded-cards(2, '.variant-shell');
//   }

//   @include media(grid-three) {
//     @include expanded-cards(3, '.variant-shell');
//   }

//   @include media(grid-four) {
//     @include expanded-cards(4, '.variant-shell');
//   }
// }

.grid--list .product-shell--showing-technical-information,
.grid--list .product-shell--show-variants {
  border-left: 0.4375rem solid color(background-blue);
}

.grid--list .product-shell--show-variants  + .product-variant-shell .variant-shell {
  border-left: 0.4375rem solid color(background-blue);
}

.variant-shell__top {
  display: flex;
  align-items: center;
  padding: measure(quarter) 0;
  position: sticky;
  left: 0;
}

.variant-shell__headline {
  @include h3-bold;
  margin-right: auto;
}

.variant-shell__headline em {
    background-color: #44B1FA;
    font-style: normal;
    color: white;
    padding: 0rem .1rem 0rem .05rem;
}

.variant-shell__headline em.instant-result__complete_match {
    background-color: #006db6;
    padding: .15rem .4rem .15rem .4rem;
    border-radius: 2px;
}

.variant-shell__actions-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: measure(half) 0;
  background-color: color(background-gray-5);
  border-bottom: 1px solid color(border-gray);
  z-index: 1;
}

.variant-shell__toggle-all {
  @include reset-button;
  @include body-smaller;
  margin-left: auto;

  &:hover {
    text-decoration: underline;
  }
}
</style>
